import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import TenableScMappingForm from './TenableScMappingForm';
import { Alert } from 'antd';

function TenableScCredentialsForm(props, ref) {
    const fields = useMemo(() => ([
          {
            name:"apiEndpoint",
            label: "URL",
            required: true,
          },
          {
            name: "accesskey",
            label: "Access Key",
            required: true,
          },
          {
            name: "secretkey",
            label: "Secret Key",
            type: FieldTypes.PASSWORD,
            required: true,
          },
          {
            name: "message",
            type: FieldTypes.LABEL,
            value: <Alert type='warning' message="Vulnerabilities from last 180 days will be fetched, informational findings will not be included."/>
          }
        ]),
        []
    );

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={TenableScMappingForm}
        />
    )
}

export default forwardRef(TenableScCredentialsForm);